<script lang="ts">
  import { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import { portal } from "svelte-portal"
  import { getDealerThemeTokensStyle } from "website_script/lib/dealerTheme"

  export let target: HTMLElement
  export let theme: DealerTheme
</script>

<div use:portal={target} style={getDealerThemeTokensStyle(theme)}>
  <slot />
</div>
